<template>
  <!-- 详情页 -->

  <div class="detail">
    <!-- 顶部搜索框 -->
    <scroller :on-refresh="refresh">
      <div class="container">
        <div class="row">
          <div class="col-md-8 offset-md-2">
            <Search :pages="routeLive" />
            <div class="detailDes">
              <img :src="liveInfo.liveCoverImg" alt="暂无图片" />
            </div>

            <!-- 免费显示 -->
            <course-means
              :liveInfo="liveInfo"
              v-on:reloadPage="getLiveInfo"
              :userId="user.userId"
            ></course-means>
            <!-- 推荐主题 -->
            <div class="catIntr">
              <div class="catIntr-title">
                <img src="../../../assets/img/recommend.png" />
                <span>相关直播</span>
              </div>
              <live-info-item
                :liveStatus="item.liveStatus + ''"
                v-for="(item, index) in dataForm.liveList"
                :key="index"
                :liveCoverImg="item.liveCoverImg"
                :liveAmt="item.liveAmt"
                :liveLecturers="item.liveLecturers"
                :liveName="item.liveName"
                :liveId="item.liveId"
                :livePay="item.livePay"
                :liveStartTime="item.liveStartTime"
                :liveEndTime="item.liveEndTime"
                :liveAttr="item.liveAttr"
              ></live-info-item>
              <div class="infoItem">
                <div
                  v-if="pageIndex < dataForm.totalPage"
                  style="
                    text-align: center;
                    font-size: 12px;
                    color: #666;
                    margin-top: 10px;
                  "
                  @click="loadMore"
                >
                  点击加载更多...
                </div>
                <div
                  v-else
                  style="
                    text-align: center;
                    font-size: 12px;
                    color: #666;
                    margin-top: 10px;
                  "
                >
                  暂无更多直播...
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </scroller>

    <!-- 底部导航 -->
    <div class="container footer">
      <div class="row footer">
        <div class="col-md-8 offset-md-2 footer">
          <div class="detailBottombar">
            <div class="shoucang" @click="Collect">
              <img
                :src="
                  !liveInfo.isCollect
                    ? require('../../../assets/img/shoucang .png')
                    : require('../../../assets/img/collect_active.png')
                "
                alt
              />
              <p>收藏</p>
            </div>
            <div class="dianzan" @click="Fabulous">
              <img
                :src="
                  !liveInfo.isThumbs
                    ? require('../../../assets/img/dianzan.png')
                    : require('../../../assets/img/dianzan_active.png')
                "
                alt
              />
              <p>点赞</p>
            </div>
            <button
              :class="{
                detShow: detShows,
                stopWatch: isPerfect == 3 || payDisabled,
                course: isPerfect != 3,
              }"
              @click="payHandel"
              v-if="liveInfo.isPurchase === 1"
              :disabled="payDisabled"
            >
              立即购买
            </button>
            <button
              :class="{
                detShow: detShows,
                stopWatch: isPerfect == 3,
                course: isPerfect != 3,
              }"
              @click="addUserSigUp(liveInfo.isSignUp)"
              v-else-if="liveInfo.isSignUp !== 0"
            >
              {{ checkStatus(liveInfo.isSignUp) }}
            </button>
            <button
              :class="{
                detShow: detShows,
                stopWatch: isPerfect == 3,
                course: isPerfect != 3,
              }"
              @click="video()"
              v-else
            >
              {{ liveInfo.liveStatus === 2 ? '观看回放' : '观看直播' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Search from '../../../components/Search'
import CourseMeans from '../../../components/details/CourseMeans'
import {
  commonShare,
  shareTitle,
  shareUrl,
  shareImg,
  shareDesc,
} from '@/common/wxshare'
import LiveInfoItem from '../../../components/live/LiveInfoItem'
export default {
  beforeRouteLeave(to, form, next) {
    var node = document.getElementsByTagName('body')[0]
    if (node.classList.contains('van-overflow-hidden')) {
      this.$router.go(1)
      return
    }
    next()
  },
  components: { Search, CourseMeans, LiveInfoItem },
  data() {
    return {
      // liveHistory:false,
      slectedValue: '0',
      detShows: true,
      payDisabled: false,
      liveId: this.$route.query.liveId,
      selected: 'means',
      dataForm: {
        currPage: 0,
        liveList: [],
        pageSize: 0,
        totalCount: 0,
        totalPage: 0,
      },
      pageIndex: 1,
      busy: false,
      routeLive: '',
      liveInfo: {},
      user: {},
      isPerfect: 0,
    }
  },
  mounted() {
    this.routeLive = sessionStorage.getItem('routeLive')
    this.user = JSON.parse(sessionStorage.getItem('userInfo'))
    this.getLiveInfo()
  },

  created() {
    let config = {}
    config.url = window.location.href
    // 判断当前url是否存在?参数匹配符
    if (!config.url.match(/\?/)) {
      location.replace(
        window.location.href.split('#')[0] + '?' + window.location.hash
      )
      return
    }
  },
  watch: {
    $route: 'refresh',
  },
  methods: {
    getLiveInfo() {
      let token = sessionStorage.getItem('token')
      this.$http({
        url: `/client/live/getLiveDetails/${this.liveId}`,
        method: 'post',
        headers: {
          authorization: token,
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.liveInfo = data.data
          this.isPerfect = this.liveInfo.isPerfect
          this.detShows = false
          this.getLiveList(this.pageIndex)
          this.wxShare(this.liveInfo)
        } else if (data.code == 500) {
          this.$toast('该直播不存在!')
          setTimeout(() => {
            this.$router.go(-1)
          }, 2000)
        }
      })
    },
    // 加载更多
    loadMore() {
      this.pageIndex++
      if (this.pageIndex <= this.dataForm.totalPage) {
        this.getLiveList(this.pageIndex)
      }
    },
    getLiveList(page) {
      this.$http({
        url: '/live/live/queryList/',
        method: 'get',
        params: {
          catId: this.liveInfo.catId,
          page: page,
          limit: 10,
          liveId: this.liveId,
        },
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.dataForm.liveList = this.dataForm.liveList.concat(data.data.list)
          this.dataForm.pageSize = data.data.pageSize
          this.dataForm.totalCount = data.data.totalCount
          this.dataForm.totalPage = data.data.totalPage
          this.dataForm.currPage = data.data.currPage
        } else {
          this.dataForm.liveList = []
          this.pageIndex = 1
        }
      })
      this.busy = false
    },
    refresh() {
      location.reload()
    },
    // 跳转到分类详情
    getCatDetail(catId) {
      this.$router.push({
        path: '/catDetail',
        query: {
          catId: catId,
        },
      })
    },
    //校验报名状态
    checkStatus(val) {
      let str = '立即报名'
      switch (val) {
        case 2:
          str = '审核中'
          break
        case 3:
          str = this.liveInfo.liveStatus === 2 ? '观看回放' : '观看直播'
          break
        case 4:
          str = '已驳回'
          break
      }

      return str
    },
    Collect() {
      if (this.liveInfo.isCollect) {
        this.cancleCollect()
      } else {
        this.addCollect()
      }
    },
    // 添加收藏
    addCollect() {
      if (this.user.userId === '') {
        return this
      }
      let flag = false

      if (!flag) {
        flag = true
        this.$http({
          url: '/live/userInterest/save',
          method: 'post',
          data: {
            liveId: this.liveId,
            userId: this.user.userId,
            status: 2,
          },
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$toast('已收藏')
            this.getLiveInfo()
          } else {
            this.$toast('收藏失败，请稍后再试')
          }
        })
      }
    },
    // 取消收藏
    cancleCollect() {
      this.$http({
        url: '/live/userInterest/removeInterest',
        method: 'delete',
        data: {
          userId: this.user.userId,
          liveId: this.liveId,
          status: 2,
        },
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.getLiveInfo()
          this.$toast('取消收藏')
        } else {
          this.$toast('取消收藏失败，请稍后再试')
        }
      })
    },
    Fabulous() {
      if (this.liveInfo.isThumbs) {
        this.cancleFabulous()
      } else {
        this.addFabulous()
      }
    },
    // 添加点赞
    addFabulous() {
      if (this.user.userId === '') {
        return this
      }
      let flag = false

      if (!flag) {
        flag = true
        this.$http({
          url: '/live/userInterest/save',
          method: 'post',
          data: {
            liveId: this.liveId,
            userId: this.user.userId,
            status: 3,
          },
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$toast('已点赞')
            this.getLiveInfo()
          } else {
            this.$toast('点赞失败，请稍后再试')
          }
        })
      }
    },
    // 取消点赞
    cancleFabulous() {
      this.$http({
        url: '/live/userInterest/removeInterestFabulous',
        method: 'delete',
        data: {
          userId: this.user.userId,
          liveId: this.liveId,
          status: 3,
        },
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.getLiveInfo()
          this.$toast('取消点赞')
        } else {
          this.$toast('取消点赞失败，请稍后再试')
        }
      })
    },
    // 添加报名
    addUserSigUp(status) {
      // 1.校验用户信息是否完整
      if (this.isPerfect === 0) {
        this.$toast('请完善资料')
        this.$router.push({
          name: 'Certification',
          params: { liveId: this.liveId },
        })
        return this
      }
      // 2.校验直播是否禁播
      if (this.liveInfo.isPerfect == 3) {
        this.$toast('无法观看')
        return this
      }
      // 3.校验用户是否有权报名
      let arr = this.liveInfo.liveRootType.split(',')
      if (
        this.user.userType !== 3 &&
        !arr.includes('0') &&
        !arr.includes(this.user.userType + '')
      ) {
        this.$toast(
          `该直播仅限${
            this.liveInfo.liveRootType === '1' ? '患者' : '医生'
          }观看`
        )
        return this
      }
      if (status === 4) {
        this.$toast('已驳回状态不允许重新报名！')
        return this
      }

      if (status === 2) {
        this.$toast('正在审核中、请稍后')
        return this
      }

      if (status === 3) {
        this.video()
        return this
      }

      //是否完善报名信息
      if (
        status === 1 &&
        this.liveInfo.isDynamicSignUp === 0 &&
        this.liveInfo.dynamicSignUpStatus === 0
      ) {
        this.$toast('请完善报名信息')
        this.$router.push({
          name: 'SignIn',
          query: {
            userId: this.user.userId,
            actId: this.liveInfo.actId,
            liveId: this.liveId,
            source: 1,
            type: 1,
          },
        })
        return this
      }

      //需要报名
      if (status === 1) {
        let flag = false
        if (!flag) {
          flag = true
          this.$http({
            url: `/client/live/signUp/${this.liveId}`,
            method: 'post',
            headers: {
              authorization: sessionStorage.getItem('token'),
            },
          }).then(({ data }) => {
            if (data && data.code === 0) {
              if (this.liveInfo.isSignUp === 3) {
                this.$toast('报名成功!')
              }
              this.getLiveInfo()
            } else {
              this.$toast('报名失败，请稍后再试')
            }
          })
        }
      }
    },
    async video() {
      const _this = this
      // 1. 校验用户资料是否完善
      if (_this.isPerfect == 0) {
        _this.$toast('请完善资料')
        _this.$router.push({
          name: 'Certification',
          params: { liveId: _this.liveId },
        })
        return _this
      }
      // 2.校验直播是否禁播
      if (_this.liveInfo.isPerfect == 3) {
        _this.$toast('无法观看')
        return _this
      }
      // 3. 校验观看权限
      let arr = _this.liveInfo.liveRootType.split(',')
      if (
        _this.user.userType !== 3 &&
        !arr.includes('0') &&
        !arr.includes(_this.user.userType + '')
      ) {
        _this.$toast(
          `该直播仅限${
            _this.liveInfo.liveRootType === '1' ? '患者' : '医生'
          }观看`
        )
        return _this
      }

      if (
        !arr.includes('0') &&
        _this.liveInfo.userType == 3 &&
        _this.liveInfo.isAuth != 2
      ) {
        if (_this.liveInfo.isAuth == 0) {
          _this.$toast('请重新完善资料')
        } else if (_this.liveInfo.isAuth == 1) {
          _this.$toast('正在认证中，请稍后再来观看')
        } else {
          //3
          _this.$toast('认证被驳回，请重新完善资料')
        }

        return _this
      }

      // 4.校验直播是否开启
      //       if (_this.liveInfo.liveStatus === 0) {
      //         _this.$toast('该直播暂未开始，不能观看')
      //         return _this
      //       }

      let data = await this.checkStart(_this.liveId)

      if (data.code !== 0 || !data.data.start) {
        _this.$toast('该直播暂未开始，不能观看')
        return _this
      }

      // 5.校验完成-播放
      _this.$router.push({
        path: '/video',
        query: { liveId: _this.liveId },
      })
    },
    checkStart(liveId) {
      return new Promise((resolve, reject) => {
        this.$http({
          url: '/live/live/checkStart/' + liveId,
          method: 'get',
        }).then((data) => {
          resolve(data.data)
        })
      })
    },
    // 立即购买
    payHandel() {
      const _this = this
      _this.payDisabled = true
      //1. 校验金额
      if (_this.liveInfo.liveAmt <= 0) {
        _this.$toast('支付金额为0')
        _this.payDisabled = false
        return _this
      }

      //2. 校验用户资料是否完善
      if (_this.isPerfect == 0) {
        _this.payDisabled = false
        _this.$toast('请完善资料')
        _this.$router.push({
          name: 'Certification',
          params: { liveId: _this.liveId },
        })

        return _this
      }
      // 3.校验直播是否禁播
      if (_this.liveInfo.isPerfect == 3) {
        _this.payDisabled = false
        _this.$toast('无法观看')
        return _this
      }

      // 3. 校验观看权限
      let arr = _this.liveInfo.liveRootType.split(',')
      if (
        _this.user.userType !== 3 &&
        !arr.includes('0') &&
        !arr.includes(_this.user.userType + '')
      ) {
        _this.$toast(
          `该直播仅限${
            _this.liveInfo.liveRootType === '1' ? '患者' : '医生'
          }观看`
        )
        return _this
      }

      if (
        !arr.includes('0') &&
        _this.liveInfo.userType == 3 &&
        _this.liveInfo.isAuth != 2
      ) {
        if (_this.liveInfo.isAuth == 0) {
          _this.$toast('请重新完善资料')
        } else if (_this.liveInfo.isAuth == 1) {
          _this.$toast('正在认证中，请稍后再来观看')
        } else {
          //3
          _this.$toast('认证被驳回，请重新完善资料')
        }

        return _this
      }

      // 分享后判断是否有权购买
      if (typeof WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', _this.pay(), false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', _this.pay())
          document.attachEvent('onWeixinJSBridgeReady', _this.pay())
        }
      } else {
        _this.pay()
      }
    },
    pay() {
      const openId = sessionStorage.getItem('openId')
      const _this = this
      _this
        .$http({
          url: '/live/live/pay/unifiedOrder',
          method: 'get',
          params: {
            liveId: _this.liveId,
            openId: openId,
          },
        })
        .then(({ data }) => {
          if (data && data.code === 0) {
            _this.onBridgeReady(data.data)
          } else {
            _this.$toast(data.msg)
            _this.payDisabled = false
          }
        })
    },
    // 调用微信支付
    onBridgeReady(data) {
      const _this = this
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        {
          appId: data.appId, // 公众号名称，由商户传入
          timeStamp: data.timeStamp + '', // 时间戳，自1970年以来的秒数
          nonceStr: data.nonceStr, // 随机串
          package: data.package,
          signType: data.signType, // 微信签名方式：
          paySign: data.paySign, // 微信签名
        },
        function (res) {
          if (res.err_msg === 'get_brand_wcpay_request:ok') {
            _this.payDisabled = false
            location.reload()
            // 使用以上方式判断前端返回,微信团队郑重提示：
            // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
            _this.payDisabled = false
            _this.$toast('支付取消!')
          } else {
            _this.payDisabled = false
            _this.$toast('支付失败!')
          }

          location.reload()
        }
      )
    },
    wxShare(liveInfo) {
      //分享
      let shareTitle = liveInfo.liveName
      let shareUrl = location.href
      let shareImg = liveInfo.livePosterImg || liveInfo.liveCoverImg
      let shareDesc =
        liveInfo.liveStartTime +
        '-' +
        liveInfo.liveEndTime +
        ' ' +
        liveInfo.liveLecturers
      commonShare(this, shareTitle, shareUrl, shareImg, shareDesc)
    },
  },
}
</script>

<style lang='scss' scoped>
.detShow {
  display: none;
}
.catIntr {
  padding: 1rem 15px;
  margin: 1rem 0;
  border-bottom: 10px solid #eee;
  margin-bottom: 6rem;
  .catIntr-title {
    display: flex;
    align-items: center;
    padding-bottom: 1rem;
    // font-weight: bold;
    img {
      width: 20px;
      margin-bottom: 3px;
      margin-right: 5px;
    }
    span {
      font-size: $font-title;
      // font-weight: bold;
    }
  }
}
.noCourse {
  text-align: center;
  padding: 20px 0;
  color: #666;
  font-size: 14px;
}
/* 每一个图文项目的外层 */
a {
  text-decoration: none;
  color: #333;
}
.inforItemText {
  margin-left: 2rem;
  width: 65%;
  // line-height: 35px;
}
/* 图文项目的标题信息 */
.infoItemTitle {
  font-size: $font-title2;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: -o-ellipsis-lastline;
}
/* 图文项目的内容信息(弹性布局) */
.infoItemContent:last-child {
  border-bottom: 0;
}
.infoItemContent {
  display: flex;
  align-items: center;
  padding: 0.2rem 0;
  margin: 0.2rem 0;
  width: 100%;
  border-bottom: 1px solid #eee;
}
/* 图文项目的内容信息--图片 */
.infoItemImg {
  width: 100px;
  height: 75px;
  border-radius: 5px;
}
/* 图文项目的内容信息--简介 */
.infoItemDes {
  line-height: 20px;
  color: #666;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  margin: 5px 0;
}
.recom {
  margin: 1rem;
}
.practicePrice {
  color: red;
}
.mint-button {
  background-color: $theme-color;
  color: #fff;
  height: 40px;
}
// /deep/ .mint-cell-title {
//   color: #333;
// }
/deep/ .mint-cell-value {
  color: #333;
}
/deep/ .mint-popup-bottom {
  width: 100%;
  color: #333;
}
.close {
  width: 24px;
  height: 24px;
}
.detailTabbar {
  margin-top: 1rem;
}
.detail {
  margin-bottom: 6rem;
}
.detailDes {
  position: relative;
  // margin-top: 1rem;
  height: 22rem;
  padding: 0 1rem;
  // font-weight: bold;
  img {
    border-radius: 5px;
    width: 100%;
    height: 100%;
  }
  a {
    color: $theme-color;
    position: absolute;
    top: 15rem;
    left: 2rem;
    z-index: 1000;
  }
}
.footer {
  position: fixed;
  bottom: -1px;
}
.detailBottombar {
  display: flex;
  text-align: center;
  justify-content: space-between;
  background-color: #fff;
  .shoucang {
    color: #666;
    padding-left: 20px;
    margin: 0 auto;
    img {
      width: 18px;
      margin-top: 5px;
    }
    p {
      font-size: 14px;
    }
  }
  .dianzan {
    color: #666;
    padding-right: 20px;
    margin: 0 auto;
    img {
      width: 20px;
      margin-top: 5px;
    }
    p {
      font-size: 14px;
    }
  }
}
.course {
  width: 50%;
  // line-height: 6rem;
  background-color: $theme-color;
  color: #fff;
  font-size: 16px;
  border: 0;
  border-radius: 3rem;
  margin: 5px;
}
.btndisabled {
  opacity: 0.6;
}
// /deep/ .mint-cell-title {
//   color: #666;
// }
.menuList > p:first-child {
  margin: 1rem 0;
  padding: 0.5rem 0;
  color: #333;
  font-size: $font-title;
  width: 28rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.menuList ~ button {
  border: 1px solid $theme-color;
  background-color: #fff;
  color: $theme-color;
}
.menuList + button {
  border: 1px solid #d81e06;
  color: #d81e06;
}
.stopWatch {
  width: 50%;
  color: #fff;
  font-size: 16px;
  border: 0;
  border-radius: 3rem;
  margin: 5px;
  background-color: rgb(200, 199, 199);
}
</style>
